<template>
  <div id="page">
    <div class="sidebar" :class="isOpened ? 'open' : ''">
      <div class="header">
        <!-- <i class="icofont-navigation-menu" id="btn" @click="toggleSidebar()" /> -->
        <img src="@/assets/images/logo-mini.png" alt="" />
        <i
          class="icon-btn"
          @click="toggleSidebar()"
          :class="isOpened ? 'icofont-circled-left' : 'icofont-circled-right'"
        ></i>
        <div class="logo_name">eSUS Feedback</div>
      </div>
      <div class="sidebar-menu">
        <ul class="nav-list">
          <span>
            <li>
              <router-link to="/">
                <i class="icofont-home" />
                <span class="links_name">Início</span>
              </router-link>
              <span class="tooltip"> Início </span>
            </li>
            <li>
              <router-link to="/nosso-dia-a-dia">
                <i class="icofont-book" />
                <span class="links_name">Nosso dia a dia</span>
              </router-link>
              <span class="tooltip"> Nosso dia a dia </span>
            </li>
            <li>
              <router-link to="/uso-cientifico">
                <i class="icofont-book" />
                <span class="links_name">Uso científico</span>
              </router-link>
              <span class="tooltip"> Uso científico </span>
            </li>
            <!--
              <li>
                <router-link to="/recursos">
                  <i class="icofont-star" />
                  <span class="links_name">RECURSOS</span>
                </router-link>
                <span class="tooltip">
                  RECURSOS
                </span>
              </li>
              -->
            <li>
              <a href="#" @click.prevent.stop="openModalContact()">
                <i class="icofont-phone" />
                <span class="links_name">Contato</span>
              </a>
              <span class="tooltip"> Contato </span>
            </li>
            <li>
              <router-link to="/avaliacoes">
                <i class="icofont-comment" />
                <span class="links_name">Avaliações</span>
              </router-link>
              <span class="tooltip"> Avaliações </span>
            </li>
            <li>
              <a href="https://politica.esusfeedback.com.br/" target="_blank">
                <i class="icofont-law-document"></i>
                <span class="links_name">Política de privacidade</span>
              </a>
              <span class="tooltip"> Política de privacidade </span>
            </li>
            <li>
              <router-link to="/termos-de-uso">
                <i class="icofont-law-document"></i>
                <span class="links_name">Termos de uso</span>
              </router-link>
              <span class="tooltip"> Termos de uso </span>
            </li>
            <li>
              <a href="/login" target="_blank">
                <i class="icofont-user-alt-7"></i>
                <span class="links_name">Acesso Restrito</span>
              </a>
              <span class="tooltip"> Acesso Restrito </span>
            </li>
            <li>
              <router-link to="/demonstracao">
                <i class="icofont-user-alt-7"></i>
                <span class="links_name">Demonstração</span>
              </router-link>
              <span class="tooltip"> Demonstração </span>
            </li>
            <li class="dropdown">
              <a
                href="#"
                @click.prevent.stop="openDropdown('myDropdownDocumentacao')"
              >
                <i class="icofont-file-document"></i>
                <span class="links_name">
                  Documentação
                  <i class="icofont-caret-down"></i>
                </span>
              </a>

              <ul
                id="myDropdownDocumentacao"
                class="dropdown-content my-dropdown-2-content"
              >
                <li>
                  <a
                    href="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-2631"
                    target="_blank"
                  >
                    Documentação atual
                  </a>
                </li>
                <li>
                  <a href="/documentacao" target="_blank">
                    <s>Documentação descontinuada</s>
                  </a>
                </li>
              </ul>
            </li>
            <li class="dropdown">
              <a href="#" v-on:click.prevent.stop="openDropdown('myDropdown2')">
                <i class="icofont-money"></i>
                <span class="links_name">
                  Cofinan. federal
                  <i class="icofont-caret-down"></i>
                </span>
              </a>
              <ul
                id="myDropdown2"
                class="dropdown-content show-dropdown my-dropdown-2-content"
              >
                <li>
                  <router-link to="/cofinanciamento/ranking-geral"
                    >Ranking geral</router-link
                  >
                </li>
                <li>
                  <router-link to="/cofinanciamento/ranking-regional"
                    >Ranking regional</router-link
                  >
                </li>
                <li>
                  <router-link to="/cofinanciamento/ranking-porte-populacional"
                    >Ranking porte populacional</router-link
                  >
                </li>
                <li>
                  <hr />
                </li>
                <li>
                  <router-link to="/cofinanciamento/mapa-ied"
                    >Mapa IED</router-link
                  >
                </li>
                <li>
                  <router-link to="/cofinanciamento/mapa-ubs" target="_blank"
                    >Mapa UBS</router-link
                  >
                </li>
                <li>
                  <router-link to="/cofinanciamento/simulacao"
                    >Simulação</router-link
                  >
                </li>
              </ul>
            </li>
            <li class="dropdown show-dropdown">
              <a href="#" v-on:click.prevent.stop="openDropdown('myDropdown')">
                <img src="@/assets/images/logopb.png" alt="" />
                <span class="links_name">
                  <s>Previne Brasil</s>
                  <i class="icofont-caret-down"></i>
                </span>
              </a>
              <!-- <span class="tooltip">
                  Previne Brasil
                </span> -->
              <ul id="myDropdown" class="dropdown-content">
                <li>
                  <router-link to="/previne-brasil/lista"
                    >Ranking geral</router-link
                  >
                </li>
                <li>
                  <router-link to="/previne-brasil/estados"
                    >Ranking estados</router-link
                  >
                </li>
                <li>
                  <router-link to="/previne-brasil/regional"
                    >Ranking regional</router-link
                  >
                </li>
                <li>
                  <router-link to="/previne-brasil/municipios-na-meta"
                    >% Municípios na meta</router-link
                  >
                </li>
                <li>
                  <hr />
                </li>
                <li>
                  <router-link to="/previne-brasil/mapa-desempenho"
                    >Mapa Desempenho</router-link
                  >
                </li>
              </ul>
            </li>
            <!--
                <li>
                <a href="/orcamento" target="_blank">
                  <i class="icofont-tasks-alt"></i>
                  <span class="links_name">Orçamento</span>
                </a>
                <span class="tooltip">
                  Orçamento
                </span>
              </li>
              <li>
                <a href="/relatorio" target="_blank">
                  <i class="icofont-tasks-alt"></i>
                  <span class="links_name">Relatório</span>
                </a>
                <span class="tooltip">
                  Relatório
                </span>
              </li> -->
          </span>
        </ul>
      </div>
    </div>
    <div class="content" :class="isOpened ? 'content-open' : ''">
      <router-view @closeMenu="closeMenu"></router-view>
    </div>
    <div id="myModal" class="modal-contact modal" v-if="active">
      <div class="modal-content">
        <span class="close" @click="active = false">&times;</span>
        <h3><i class="icofont-ui-contact-list"></i> Contatos</h3>
        <p>
          Seleciona o seu estado e sua cidade para obter os dados de contato.
        </p>
        <div class="row">
          <div class="col-12 col-lg-6">
            <div class="form-group input-group">
              <vue-select
                :options="estados"
                label="uf"
                placeholder="ESTADO"
                @input="onChangeEstados"
                class="vue-select-estado"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group input-group">
              <vue-select
                :options="cidades"
                label="no_municipio"
                placeholder="CIDADE"
                @input="onChangeCidades"
                class="vue-select-cidade"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
          </div>
          <div class="col-12">
            <div class="contatos">
              <ul v-if="contato.cpf != null">
                <li><i class="icofont-envelope"></i> {{ contato.email }}</li>
                <li>
                  <i class="icofont-phone"></i> {{ contato.contato1 | phone }}
                </li>
                <li>
                  <i class="icofont-phone"></i> {{ contato.contato2 | phone }}
                </li>
              </ul>
              <ul v-else>
                <li><i class="icofont-envelope"></i> contato@biatic.com.br</li>
                <li><i class="icofont-phone"></i> (83) 99841-4823</li>
                <li><i class="icofont-phone"></i> (83) 98206-1060</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'Index',
  components: {
    'vue-select': VueSelect,
  },
  filters: {
    phone: function (value) {
      return value
        .replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    },
  },
  beforeMount() {
    if (window.innerWidth < 1023) {
      this.isOpened = false
    } else {
      this.isOpened = true
    }
  },
  data() {
    return {
      isOpened: true,
      active: false,
      estados: [
        { uf: 'AC' },
        { uf: 'AL' },
        { uf: 'AP' },
        { uf: 'AM' },
        { uf: 'BA' },
        { uf: 'CE' },
        { uf: 'DF' },
        { uf: 'ES' },
        { uf: 'GO' },
        { uf: 'MA' },
        { uf: 'MT' },
        { uf: 'MS' },
        { uf: 'MG' },
        { uf: 'PA' },
        { uf: 'PB' },
        { uf: 'PR' },
        { uf: 'PE' },
        { uf: 'PI' },
        { uf: 'RJ' },
        { uf: 'RN' },
        { uf: 'RS' },
        { uf: 'RO' },
        { uf: 'RR' },
        { uf: 'SC' },
        { uf: 'SP' },
        { uf: 'SR' },
        { uf: 'TO' },
      ],
      estado: '',
      cidade: '',
      cidades: [],
      contato: {
        email: '',
        contato1: '',
        contato2: '',
        cpf: '',
      },
    }
  },
  methods: {
    closeMenu() {
      this.isOpened = false
    },
    toggleSidebar() {
      this.isOpened = !this.isOpened
    },

    scrollElement(id) {
      let route = this.$router.history.current.path
      if (
        route == '/termos-de-uso' ||
        route == '/criar-conta' ||
        route == '/recuperar-senha'
      ) {
        this.$router.push('/' + id)
      } else {
        let tag = document.getElementById(id)
        window.scroll({
          behavior: 'smooth',
          left: 0,
          top: tag.offsetTop - 180,
        })
      }
    },
    buscarCidades(estado) {
      this.$apiPublic
        .get('/cidades-por-uf/' + estado)
        .then((response) => {
          this.cidades = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    onChangeEstados(event) {
      let estado = event.uf
      this.$apiPublic
        .get('/cidades-por-uf/' + estado)
        .then((response) => {
          this.cidades = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    onChangeCidades(event) {
      this.cidade = event.co_ibge
      this.$apiPublic
        .get('/contatos/' + this.cidade)
        .then((response) => {
          this.contato.email = response.data[0].email_contato
          this.contato.contato1 = response.data[0].celular_contato1
          this.contato.contato2 = response.data[0].celular_contato2
          this.contato.cpf = response.data[0].cpf_contato
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    openDropdown(id) {
      document.getElementById(id).classList.toggle('show-dropdown')
    },

    openModalContact() {
      this.active = true
      this.isOpened = false
    },
  },
}
</script>

<style lang="scss">
$primary-color: #0d98bb;
$background-color: #f4f6fd;
$sidebar-background: #fff;
$hover-background: #f2f2f2;
$dropdown-background: #f2f2f2;
$text-color: #000;
$scrollbar-color: #ccc;
$scrollbar-hover-color: #aaa;
$transition-default: 0.5s ease;

#page {
  background-color: $background-color;
}

/* =========================================================
   SIDEBAR
========================================================= */

.sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  display: flex;
  flex-direction: column;
  width: 65px;
  height: 100vh;
  background: $sidebar-background;
  box-shadow: 0 0 21px rgb(89 102 122 / 10%);
  transition: all $transition-default;
  z-index: 99;

  &.open {
    width: 300px;

    .header {
      .logo,
      .logo_name {
        opacity: 1;
      }
    }

    .links_name {
      opacity: 1;
      pointer-events: auto;
    }

    .show-dropdown {
      display: block !important;
    }

    li:hover {
      .tooltip {
        opacity: 0;
        pointer-events: none;
      }
    }
  }

  i {
    min-width: 50px;
    height: 50px;
    color: $primary-color;
    font-size: 18px;
    line-height: 50px;
    text-align: center;
    border-radius: 12px;
  }

  /* =======================================================
     CABEÇALHO
  ======================================================= */

  .header {
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    height: 60px;
    margin: 6px 9px 0;

    img {
      width: 30px;
      margin: 0 10px;
    }

    .logo {
      opacity: 0;
      transition: all $transition-default;
    }

    .logo_name {
      color: $text-color;
      font-size: 20px;
      font-weight: 600;
      opacity: 0;
      white-space: nowrap;
      transition: all $transition-default;
    }

    .icon-btn {
      position: absolute;
      right: -34px;
      cursor: pointer;
      z-index: 999;
    }

    #btn {
      font-size: 23px;
      text-align: center;
      cursor: pointer;
      transition: all $transition-default;
    }
  }

  /* =======================================================
     ÁREA COM SCROLL
  ======================================================= */

  .sidebar-menu {
    flex: 1;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-width: thin;
    scrollbar-color: $scrollbar-color transparent;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: $scrollbar-color;
      border-radius: 6px;

      &:hover {
        background-color: $scrollbar-hover-color;
      }
    }
  }

  /* =======================================================
     LISTA DO MENU
  ======================================================= */

  .nav-list {
    margin-top: 20px;
    padding-bottom: 20px;
  }

  li {
    position: relative;
    list-style: none;

    &:hover {
      background-color: $hover-background;
      box-shadow: 3px 0 0 0 $primary-color inset;

      > .tooltip {
        top: 50%;
        opacity: 1;
        pointer-events: auto;
        transform: translateY(-50%);
      }
    }

    ul {
      li {
        margin-bottom: 0px;
      }
    }

    a {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      margin: 0 8px;
      border-radius: 12px;
      text-decoration: none;
      transition: all 0.4s ease;

      &:hover {
        .links_name,
        i {
          transition: all $transition-default;
        }
      }

      .links_name {
        color: $text-color;
        font-size: 16px;
        font-weight: 400;
        white-space: nowrap;
        opacity: 0;
        pointer-events: none;
        transition: all 0.4s ease;
      }
    }

    .tooltip {
      position: absolute;
      top: -20px;
      left: calc(100% + 15px);
      padding: 6px 12px;
      color: #fff;
      font-size: 15px;
      font-weight: 400;
      white-space: nowrap;
      background: $primary-color;
      border-radius: 4px;
      box-shadow: 0 5px 10px rgb(0 0 0 / 30%);
      opacity: 0;
      pointer-events: none;
      transition: all 0.4s ease;
      z-index: 3;
    }
  }

  /* =======================================================
     DROPDOWN COM SIDEBAR FECHADA
  ======================================================= */

  &:not(.open) {
    .dropdown {
      &:hover {
        .dropdown-content {
          position: absolute;
          top: 0;
          left: 100%;
          display: block;
          width: 220px;
          z-index: 9;
        }
      }
    }

    .footer {
      flex-direction: column;
      gap: 0;

      .social-media-item {
        &:hover {
          background-color: rgba(242, 242, 242, 0.5);
          box-shadow: 3px 0 0 0 $primary-color inset;
        }

        a {
          i {
            font-size: 18px;
          }

          h5 {
            display: none;
          }
        }
      }
    }
  }

  /* =======================================================
     RODAPÉ DA SIDEBAR
  ======================================================= */

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;

    .social-media-item {
      width: 100%;

      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: $text-color;
        text-decoration: none;

        i {
          height: 50px;
          font-size: 25px;
          line-height: 50px;
        }

        h5 {
          font-size: 14px;
        }
      }

      &.instagram {
        a {
          i {
            color: #523fcf;
          }
        }
      }

      &.youtube {
        a {
          i {
            color: red;
          }
        }
      }
    }
  }
}

/* =========================================================
   DROPDOWNS
========================================================= */

.dropdown {
  img {
    width: 25px;
    margin: 0 15px 0 10px;
  }
}

.dropdown-content {
  display: none;
  height: 230px;
  padding: 10px 27px;
  overflow-y: auto;
  background-color: $dropdown-background;
  scrollbar-width: thin;
  scrollbar-color: $scrollbar-color #f4f4f4;

  li {
    a {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      margin: 0 8px;
      color: $primary-color !important;
      font-size: 14px;
      font-weight: bold !important;
      text-decoration: none;
      border-radius: 12px;
      transition: all 0.4s ease;
    }
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f4f4f4;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $scrollbar-color;
    border-radius: 5px;

    &:hover {
      background-color: $scrollbar-hover-color;
    }
  }
}

.dropdown-submenu {
  padding: 10px 15px;

  li {
    &:hover {
      box-shadow: none;
    }
  }
}

.my-dropdown-2-content {
  height: auto;
  overflow: hidden;
}

/* =========================================================
   CONTEÚDO PRINCIPAL
========================================================= */

.content {
  transition: all $transition-default;

  &.content-open {
    padding-left: 300px !important;
  }

  &:not(.content-open) {
    padding-left: 100px !important;
  }

  .content-main {
    padding: 20px 30px 20px 30px;
  }
}

/* =========================================================
   MODAL DE CONTATO
========================================================= */

.modal-contact {
  z-index: 999 !important;

  .modal-content {
    .vue-select-estado,
    .vue-select-cidade {
      width: 100%;
    }
  }
}

#myModal {
  position: fixed;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0 0 0 / 40%);
  z-index: 999;

  .modal-content {
    width: 53%;
    margin: 5% auto;
    padding: 20px;
    background-color: #fefefe;
    border: 1px solid #888;

    h3 {
      text-align: center;
    }
  }

  .close {
    float: right;
    color: #aaa;
    font-size: 45px;
    font-weight: bold;
    text-align: right;

    &:hover,
    &:focus {
      color: #000;
      text-decoration: none;
      cursor: pointer;
    }
  }

  .modal-content-btn {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    .btn3d {
      position: relative;
      width: 210px;
      margin: 15px;
      border: 0;
      outline: none;
      transition: all 0.08s linear;

      &:focus {
        outline: none;
      }
    }
  }

  .btn-android {
    color: #fff;
    background-color: #5cb85c;
    box-shadow: 0 0 0 1px #5cb85c inset, 0 0 0 2px rgb(255 255 255 / 15%) inset,
      0 8px 0 0 #4cae4c, 0 8px 0 1px rgb(0 0 0 / 40%),
      0 8px 8px 1px rgb(0 0 0 / 50%);
  }

  .btn-apple {
    background-color: #ccc;
    box-shadow: 0 0 0 1px #fff inset, 0 0 0 2px rgb(255 255 255 / 15%) inset,
      0 8px 0 0 #ccc, 0 8px 0 1px rgb(0 0 0 / 40%),
      0 8px 8px 1px rgb(0 0 0 / 50%);
  }

  .btn-indicador {
    width: 300px !important;
    color: #fff;
    background-color: #4aa5bc;
    box-shadow: 0 0 0 1px #4aa5bc inset, 0 0 0 2px rgb(255 255 255 / 15%) inset,
      0 8px 0 0 #4aa5bc, 0 8px 0 1px rgb(0 0 0 / 40%),
      0 8px 8px 1px rgb(0 0 0 / 50%);
  }

  a {
    .button-live {
      display: block;
      width: 250px;
      margin: 15px auto;
      padding: 15px;
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      text-align: center;
      text-transform: uppercase;
      background-color: #0fafd7;
      border: none;
      border-radius: 32px;
      box-shadow: 0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%),
        0 1px 5px 0 rgb(0 0 0 / 12%);
    }
  }
}

/* =========================================================
   RESPONSIVIDADE
========================================================= */

@media screen and (max-width: 420px) {
  .sidebar {
    li {
      .tooltip {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 656px) {
  #page {
    overflow-y: hidden;
  }

  .content {
    &:not(.content-open) {
      padding-left: 60px !important;
    }

    &.content-open {
      padding-left: unset !important;
    }

    .content-main {
      padding: 20px 15px 20px 25px;
    }
  }

  .dropdown-content {
    height: 250px;
  }
}

@media screen and (min-width: 657px) and (max-width: 1023px) {
  .content {
    &:not(.content-open) {
      padding-left: 100px !important;
    }
  }

  .dropdown-content {
    height: 250px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  #myModal {
    .modal-content-btn {
      flex-direction: column;

      .btn3d {
        &.btn-android {
          margin-bottom: 0;
        }
      }
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 480px) {
  #myModal {
    .modal-content {
      width: 80%;
      margin: 15% auto;
      padding: 20px;
    }

    .modal-content-btn {
      flex-direction: column;

      .btn3d {
        width: 270px !important;
        margin: 10px;
      }
    }

    .btn-indicador {
      margin-top: 0;
      font-size: 17px;
    }
  }
}
</style>
